import InputText from "../../../../components/inputs/yup/materialui/inputText";
import { useForm } from "react-hook-form";
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect, useState } from "react";
import validaRut from "../../../../utils/validaRut";
import { useToast } from "../../../../hooks/useToast";
import InputRut from "../../../../components/inputs/yup/materialui/inputRut";
import { Dialog, DialogContent, DialogTitle, FormHelperText } from "@mui/material";
import Grid from '@mui/material/Grid2';
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import InputSwitch from "../../../../components/inputs/yup/materialui/inputSwitch";
import { StatusCode } from "../../../../utils/enums";
import { institucionFinanciera, institucionFinancieraForm } from "../models/institucionFinanciera";
import { useInstitucion } from "../hooks/useInstitucion";

interface IProps {
    show: boolean
    datosEditar: institucionFinanciera | undefined
    onHide: () => void
    refresh: () => void
    setisloading: (loading: boolean) => void
    setrefresh: (value: boolean) => void
}

const ModalInstituciones: React.FC<IProps> = ({ show, datosEditar, onHide, refresh, setisloading, setrefresh }) => {
    const { save } = useInstitucion();

    const validationSchema = yup.object().shape({
        rut: yup.string().default('').nonNullable().test('valida-rut', 'RUT inválido', function (value) {
            return validaRut.rutFormat(value);
        }).test('rut-minimo', 'La parte numérica del RUT debe ser mayor o igual a 50000000', function (value) {
            if (!value) return false;
            // Eliminar puntos y guión, dejar solo números y dígito verificador
            const rutLimpio = value.replace(/\./g, '').replace('-', '');
            // Extraer solo la parte numérica (todo excepto el último carácter que es el dígito verificador)
            const parteNumerica = parseInt(rutLimpio.slice(0, -1));
            return parteNumerica >= 50000000;
        }).required('Requerido'),
        nombre: yup.string()
            .default('')
            .nonNullable()
            .required('Requerido')
            .test('no-espacios', 'El nombre no puede contener solo espacios en blanco', function(value) {
                return value ? value.trim().length > 0 : false;
            })
            .max(30, 'Máximo 30 caractéres'),
        activo: yup.boolean().required(),
    })

        

    const {
        formState: { errors },
        handleSubmit,
        reset,
        setValue,
        control,
    } = useForm({ 
        resolver: yupResolver(validationSchema),
        defaultValues: {
            rut: '',
            nombre: '',
            activo: true
        }
    })

    const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false)
    const { addToast } = useToast();

    const onSubmit = (data: institucionFinancieraForm) => saveCompania(data)

    useEffect(() => {
        reset()
    }, [isSubmitSuccessful])

    useEffect(() => {
        if (datosEditar && show) {
            setValue('rut', datosEditar['rut'])
            setValue('nombre', datosEditar['nombre'])
            setValue('activo', datosEditar['activo'])
        } else {
            reset()
        }
    }, [datosEditar, show])

    function customOnHide() {
        reset()
        onHide()
    }

    async function saveCompania(data: institucionFinancieraForm) {
        setisloading(true)
        
        const response = await save(data, datosEditar)
        if (response.status === StatusCode.NoContent) {

            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: 'La institución financiera se guardó con éxito.'
            });

            setrefresh(true)
            setIsSubmitSuccessful(true)
            refresh();
            onHide();
            reset();

        } else {

            addToast({
                mostrar: true,
                titulo: 'Error',
                tipo: 'Danger',
                mensaje: !datosEditar
                    ? 'No fue posible agregar la institución financiera. (Verifique que el rut no esté ya registrado)'
                    : 'No fue posible guardar la institución financiera. (Considere que el rut no puede ser modificado)',
            });
        }
        
        setisloading(false)
    }

    return (
        <Dialog
            open={show}
            onClose={customOnHide}
            maxWidth='lg'
        >
            <DialogTitle>
                {datosEditar ? 'Editar institución financiera' : 'Nueva institución financiera'}
            </DialogTitle>
            <DialogContent>
                <form>
                    <Grid container spacing={4}>
                        <Grid size={4}>
                            <InputRut
                                label="RUT"
                                name="rut"
                                control={control}
                                disabled={datosEditar != null} />
                            <FormHelperText error> {errors?.rut?.message} </FormHelperText>
                        </Grid>
                        <Grid size={5}>
                            <InputText
                                name="nombre"
                                control={control}
                                label="Nombre"
                            />
                            <FormHelperText error> {errors?.nombre?.message} </FormHelperText>
                        </Grid>
                        <Grid size={3}>
                            <InputSwitch
                                name="activo"
                                control={control}
                                label="Activo"
                                error={errors.activo}
                            />
                        </Grid>
                    </Grid>
                </form>
                <Grid container spacing={1} marginTop={2} justifyContent={"flex-end"}>
                    <Grid>
                        <MButton variant="contained" onClick={handleSubmit(onSubmit)}>Guardar</MButton>
                    </Grid>
                    <Grid>
                        <MButton variant="contained" color="inherit" onClick={customOnHide}>Cancelar</MButton>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

export default ModalInstituciones

